var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCdmoDiscoveryCardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
    fill: "#EEF4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 29H25.6667",
    stroke: "#0066CC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 32.3335H31.5",
    stroke: "#0066CC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6666 32.3332C27.2137 32.3332 28.6975 31.7186 29.7914 30.6246C30.8854 29.5307 31.5 28.0469 31.5 26.4998C31.5 24.9527 30.8854 23.469 29.7914 22.375C28.6975 21.2811 27.2137 20.6665 25.6666 20.6665H24.8333",
    stroke: "#0066CC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 25.6665H23.1667",
    stroke: "#0066CC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 24C21.058 24 20.634 23.8244 20.3215 23.5118C20.0089 23.1993 19.8333 22.7754 19.8333 22.3333V19H24.8333V22.3333C24.8333 22.7754 24.6577 23.1993 24.3452 23.5118C24.0326 23.8244 23.6087 24 23.1666 24H21.5Z",
    stroke: "#0066CC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24 18.9998V16.4998C24 16.2788 23.9122 16.0669 23.7559 15.9106C23.5997 15.7543 23.3877 15.6665 23.1667 15.6665H21.5C21.279 15.6665 21.067 15.7543 20.9108 15.9106C20.7545 16.0669 20.6667 16.2788 20.6667 16.4998V18.9998",
    stroke: "#0066CC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdmoDiscoveryCardIcon);
export default __webpack_public_path__ + "static/media/cdmo-Discovery-card-icon.5337ba4c4f6429ce59f71ca4e55dfa7d.svg";
export { ForwardRef as ReactComponent };